module.exports = __webpack_public_path__ + "img/mobile-for-business.a3f905fe.png";